<template>
  <div class="section">
    <terms-and-conditions />
  </div>
</template>



<script>
  export default {
    name: 'TermsAndConditionsPage',

    metaInfo() {
      return {
        title: 'Terms & Conditions'
      };
    }
  };
</script>
